import React from "react";
import BaseModal from "../ModalComponents/BaseModal";
import "../../css/MobileNavModal.css";
import "../../css/BaseModal.css";
import { useNavigate } from "react-router-dom";
import {
  helpRoute,
  menuRoute,
  profileRoute,
  reportsRoute,
} from "../../utils/pathUtils";

/**
 * MobileNavModal component displays a modal with core and footer navigation items.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} props.isOpen - Indicates if the modal is open.
 * @param {function} props.onRequestClose - Function to close the modal.
 * @param {Array} props.coreItems - Array of core navigation items (e.g., dashboard, menu, reports).
 * @param {Array} props.footerItems - Array of footer navigation items (e.g., help, profile).
 * @param {function} props.onItemClick - Function to handle item clicks.
 * @param {string} props.fontColor - The color of the font for the modal items. The default is "#f9b09b".
 *
 * @returns {JSX.Element} The rendered MobileNavModal component.
 */
const MobileNavModal = ({
  isOpen,
  onRequestClose,
  coreItems = [],
  footerItems = [],
  onItemClick,
  fontColor = "#f9b09b",
}) => {
  const navigate = useNavigate();

  const handleNavItemClick = (item) => {
    onRequestClose();
    onItemClick(item);

    const restaurant = JSON.parse(localStorage.getItem("restaurant"));

    if (!restaurant || !restaurant.id) {
      console.error("Restaurant data is missing!");
      return;
    }

    const restaurantId = restaurant.id;
    const menuId = restaurant.menu?.id;

    // Use route constants directly
    if (item === "menu") {
      navigate(menuRoute(restaurantId, menuId));
    } else if (item === "profile") {
      navigate(profileRoute(restaurantId));
    } else if (item === "reports") {
      navigate(reportsRoute());
    } else if (item === "help") {
      navigate(helpRoute());
    } else {
      console.error(`No route found for item: ${item}`);
    }
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal-content nav-links-modal"
      overlayClassName="modal-overlay"
    >
      <div>
        <div className="mobile-nav-header">
          <div className="mobile-nav-core-items">
            {coreItems.map((item, index) => (
              <button
                key={index}
                className="nav-link"
                style={{ color: fontColor }}
                onClick={() => handleNavItemClick(item)}
              >
                {item}
              </button>
            ))}
          </div>

          <div className="mobile-nav-footer-items">
            {footerItems.map((item, index) => (
              <button
                key={index}
                className="nav-link"
                style={{ color: fontColor }}
                onClick={() => handleNavItemClick(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default MobileNavModal;
